import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import {AuthServiceCustom} from '../../shared/service/auth.service';
import {map} from 'rxjs/operators';


@Injectable()
export class NotProxyOnlyGuard  {// CanActivateChild

  constructor(private authService: AuthServiceCustom) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
    if (!this.authService.configReady) {
      return this.authService.clientConfigLoaded.pipe(map(x => {
        return this.checkAndRedirect();
      }));
    }

    return this.checkAndRedirect();
  }

  checkAndRedirect() {
    const isProxyOnly = sessionStorage.getItem('ProxyOnlyFlag') === 'Y';
    if (!isProxyOnly) {
      return true;
    } else {
      this.authService.navigateToUrl('proxy');
      return false;
    }
  }
}
